import React from 'react';
import { useLocation, useNavigate } from 'react-router';
import { NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Box, Drawer, useMediaQuery, List, ListItem, ListItemText } from '@mui/material';
import { SidebarWidth } from '../../../assets/global/Theme-variable';
import Logo1 from '../../../assets/logo.jpeg';
import Scrollbar from '../../../components/custom-scroll/Scrollbar';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

const Sidebar = ({ isMobileSidebarOpen, onSidebarClose, isSidebarOpen }) => {
  const { t } = useTranslation();
  const [open, setOpen] = React.useState(true);
  const { pathname } = useLocation();
  const roleReducer = useSelector((state) => state.RoleReducer);
  const pathDirect = pathname;
  const lgUp = useMediaQuery((theme) => theme.breakpoints.up('lg'));
  const navigate = useNavigate();

  const handleClick = (index) => {
    if (open === index) {
      setOpen((prevopen) => !prevopen);
    } else {
      setOpen(index);
    }
    onSidebarClose();
  };

  // Define the desired order for the sidebar items
  const orderedItems = [
    'home',
    'dashboard',
    'add_user',
    'users',
    'add-event',
    'event',
    'my_events',
    'adopt_ctu_list',
    'reports',
    'event_closure_report',
    'sdsd_reports',
    'create_sbm',
    'view_sbm',
    'citizen_testimonials',
    'citizen_testimonials_list',
    'partners',
    'partner_report',
    'approve_partner',
  ];

  const SidebarContent = (
    <Scrollbar style={{ height: 'calc(100vh - 5px)' }}>
      <Box sx={{ p: 2 }}>
        <div onClick={() => navigate('/')} style={{ cursor: 'pointer' }}>
          <img src={Logo1} alt="logo" style={{ width: '200px', height: '100px' }} />
        </div>
        <Box>
          <List>
            <ListItem button component={NavLink} to="/" selected={pathname === '/'}>
              <ListItemText onClick={onSidebarClose}>{t('home')}</ListItemText>
            </ListItem>
          </List>
          <List>
            {orderedItems
              .filter((item) =>
                roleReducer?.info?.page_permission?.some(
                  (perm) => perm.component.toLowerCase() === item,
                ),
              )
              .sort((a, b) => {
                const indexA = orderedItems.indexOf(a);
                const indexB = orderedItems.indexOf(b);
                return indexA - indexB;
              })
              .map((item, index) => {
                const permissionItem = roleReducer.info.page_permission.find(
                  (perm) => perm.component.toLowerCase() === item,
                );
                return (
                  <List component="li" disablePadding key={item}>
                    <ListItem
                      onClick={() => handleClick(index)}
                      button
                      component={NavLink}
                      to={permissionItem.path} // Assuming `path` exists in the permission object
                      selected={pathDirect.includes(permissionItem.path)}
                      sx={{
                        mb: 1,
                        ...(pathDirect.includes(permissionItem.path) && {
                          color: 'white',
                          backgroundColor: (theme) => `${theme.palette.primary.main}!important`,
                        }),
                      }}
                    >
                      <ListItemText onClick={onSidebarClose}>{t(item)}</ListItemText>
                    </ListItem>
                  </List>
                );
              })}
          </List>
        </Box>
      </Box>
    </Scrollbar>
  );

  if (lgUp) {
    return (
      <Drawer
        anchor="left"
        open={isSidebarOpen}
        variant="persistent"
        PaperProps={{
          sx: {
            width: SidebarWidth,
            border: '0 !important',
            boxShadow: '0px 7px 30px 0px rgb(113 122 131 / 11%)',
          },
        }}
      >
        {SidebarContent}
      </Drawer>
    );
  }

  return (
    <Drawer
      anchor="left"
      open={isMobileSidebarOpen}
      onClose={onSidebarClose}
      PaperProps={{
        sx: {
          width: SidebarWidth,
          border: '0 !important',
        },
      }}
      variant="temporary"
    >
      {SidebarContent}
    </Drawer>
  );
};

Sidebar.propTypes = {
  isMobileSidebarOpen: PropTypes.bool,
  onSidebarClose: PropTypes.func,
  isSidebarOpen: PropTypes.bool,
};

export default Sidebar;
